import { render, staticRenderFns } from "./lrNewTable.vue?vue&type=template&id=0110ed6b&"
import script from "./lrNewTable.vue?vue&type=script&lang=js&"
export * from "./lrNewTable.vue?vue&type=script&lang=js&"
import style0 from "./lrNewTable.vue?vue&type=style&index=0&id=0110ed6b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports